import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens
import config from '../config';
import actions from '../actions/actions';
import reviewPageActions from '../actions/reviewPage';

function updateAccountDetails(store, action) {
    const accountDetails = action.payload.accountDetails;
    request.put(`/${config.url_prefix}/api/updateAccountDetails`)
        .send({
            data: accountDetails
        })
        .set('x-homeaway-site', store.getState().system.siteName)
        .end((error, response) => {
            if (error) {
                store.dispatch(actions.enableLoadOverLay(false));
                store.dispatch(reviewPageActions.alertErrorForModal('ipmob.internal.server.error'));
            } else if (response.statusCode === 204) {
                store.dispatch(reviewPageActions.updateServiceSuccess());
            } else {
                store.dispatch(actions.enableLoadOverLay(false));
                store.dispatch(reviewPageActions.alertErrorForModal('ipmob.error.process.request'));
            }
        });
}

export default updateAccountDetails;
